// eslint-disable-next-line no-empty-function
export default () => {};
